import { useMediaQuery, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import { memo } from 'react';

import { TrlAsterisks } from '»components/atoms/TrlAsterisks';
import { TrlInfoIcon } from '»components/atoms/TrlInfoIcon';

import {
  FieldWrapper,
  Label,
  LabelContainer,
} from './TrlFieldContainer.styles';

export const TrlFieldContainer = memo(
  ({
    children,
    label,
    disabled,
    noPaddingTop,
    noPadding,
    isRequired,
    extraInfo,
  }) => {
    const theme = useTheme();
    const isAboveXXL = useMediaQuery(theme.breakpoints.up('xxl'));

    return (
      <FieldWrapper
        id="fieldContainer"
        noPaddingTop={noPaddingTop}
        noPadding={noPadding}
      >
        <LabelContainer
          disabled={disabled}
          title={`${label}${isRequired ? ' *' : ''}`}
        >
          <Label disabled={disabled} isRequired={isRequired}>
            {label}
          </Label>
          {isAboveXXL && <TrlAsterisks areVisible={isRequired} />}
          {extraInfo && <TrlInfoIcon infoText={extraInfo} />}
        </LabelContainer>
        {children}
      </FieldWrapper>
    );
  },
);

TrlFieldContainer.displayName = 'TrlFieldContainer';

TrlFieldContainer.propTypes = {
  children: PropTypes.element.isRequired,
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  disabled: PropTypes.bool,
  noPaddingTop: PropTypes.bool,
  noPadding: PropTypes.bool,
  isRequired: PropTypes.bool,
  extraInfo: PropTypes.string,
};
